import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectProduct, setVizLoading } from '../../../../store/visualizerSlice';
import ProductList from '../../ProductList/ProductList';
import StepNavigation from '../../StepNavigation/StepNavigation';
import styles from './Siding.module.css';

/**
 * Siding Step Component
 * Applies color directly to Body surfaces and Siding_Edge.
 * No more profile(color) setup - just color selection.
 */
export default function Siding({ 
    surfaceType = 'BODY',
    stepIndex,
    room = '',
    onViewAllApplied, 
    onNext, 
    onPrevious 
}) {
    const dispatch = useDispatch();
    const stepSelections = useSelector(state => state.visualizer.stepSelections);
    const [selectedColor, setSelectedColor] = useState(null);

    // Selection key: StepName_Room
    const selectionKey = `Siding_${room}`;

    // Restore selection from Redux on mount
    useEffect(() => {
        const savedSelection = stepSelections[selectionKey];
        if (savedSelection?.product) {
            setSelectedColor(savedSelection.product);
        }
    }, [stepSelections, selectionKey]);

    const handleColorSelect = (product) => {
        setSelectedColor(product);
        
        console.log('Siding - Color selected:', product.color || product.name);
        
        // Store selection in Redux
        dispatch(selectProduct({
            product,
            surfaceName: 'Siding',
            stepIndex,
            selectionKey
        }));

        // Apply the color
        applyColor(product);
    };

    const applyColor = (color) => {
        const chamViz = document.getElementById('chamViz');
        if (!chamViz) {
            console.error('Siding - chamViz element not found');
            return;
        }

        if (!color.id) {
            console.error('Siding - Color has no ID');
            return;
        }

        console.log('Siding - Applying color:', color.id);
        console.log('Siding - Applying to surfaces: Body 1, Body 2, Body 3, Body 4, Siding_Edge, Siding');
        
        dispatch(setVizLoading(true));
        
        // Apply to Body 1, Body 2, Body 3, Body 4, Siding_Edge, and Siding surfaces
        const targetSurfaces = ['Body 1', 'Body 2', 'Body 3', 'Body 4', 'Siding_Edge', 'Siding'];
        
        chamViz.applyByFilter(
            color.id,
            "",
            function(newSel) {
                // this = surface object { name, type, sortorder, sel }
                if (targetSurfaces.includes(this.name)) {
                    return newSel;
                }
                return this.sel;
            },
            true
        );
    };

    const handleViewAllApplied = () => {
        if (onViewAllApplied) {
            onViewAllApplied();
        }
    };

    return (
        <div className={styles.container}>
            <StepNavigation
                title="Siding"
                onNext={onNext}
                onPrevious={onPrevious}
                onViewAllApplied={handleViewAllApplied}
            />

            {/* Product List - Colors */}
            <div className={styles.productListContainer}>
                <ProductList
                    seriesId="9707"
                    thumbSize="256"
                    onProductSelect={handleColorSelect}
                    titleAttribute="color"
                    descriptionAttribute="name"
                    gridClassName={styles.productGrid}
                    selectedId={selectedColor?.id}
                />
            </div>
        </div>
    );
}

Siding.propTypes = {
    surfaceType: PropTypes.string,
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
